function windowString(source = window) {
  const sourceType = (source === window.top) ? 'window' : 'iframe';
  const location = source && source.location.href;
  return `${sourceType} ${location}`;
}

export default windowString;
